<div #stage></div>

<!-- <div class="drawin-message">
  <span
    >{{ 'x: ' + xDrawing }} <br />
    {{ 'y: ' + yDrawing }}
  </span>
</div> -->
